import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import moment from "moment/moment";
import ClonePlacementToolbar from './ClonePlacementToolbar';
import ClonePlacementForm from './ClonePlacementForm';
import PlacementValidationRules from '../placement/ValidationRules';
import { validate } from "../../utils/formValidator";
import ClonePlacementGrid from "./ClonePlacementGrid";

const styles = ( /* theme */ ) => ({
  root: {
    padding: 20
  }
});

class ClonePlacementPage extends Component {
  static genNewName = (item, idx) => {
    if (!item.increment) {
      return item.base;
    }
    return isNaN(item.base) ? `${item.base}${Number(item.start) + idx}` :
      `${Number(item.base) + Number(item.start) + idx}`;
  };

  static genNewDate = (baseDate, adjustTo ,duration, increment) => {
    return moment(baseDate).add(increment, duration)[adjustTo](duration)[adjustTo]('day').format();
  };

  static createPlacementCopies(placement, cloneSettings) {
    const clonedPlacements = [];
    for (let i = 0; i < cloneSettings.copies; ++i) {
      clonedPlacements.push({
        agencyPlacementId: ClonePlacementPage.genNewName(cloneSettings.agencyPlacementId, i),
        agencyPlacementName: ClonePlacementPage.genNewName(cloneSettings.agencyPlacementName, i),
        billingGroup: ClonePlacementPage.genNewName(cloneSettings.billingGroup, i),
        start: ClonePlacementPage.genNewDate(
          placement.start,
          'startOf',
          cloneSettings.dates.base,
          (cloneSettings.dates.increment) ? i + 1 : 1),
        end: ClonePlacementPage.genNewDate(
          placement.end,
          'endOf',
          cloneSettings.dates.base,
          (cloneSettings.dates.increment) ? i + 1 : 1)
      });
    }
    return clonedPlacements;
  }

  constructor(props) {
    super(props);
    this.placementValidationRules = PlacementValidationRules(props.order);
    props.placement.billingGroup = props.placement.billingGroup || '';
    this.state = {
      cloneSettings: {
        copies: 0,
        agencyPlacementName: {
          base: props.placement.agencyPlacementName,
          increment: false,
          start: 1
        },
        agencyPlacementId: {
          base: props.placement.agencyPlacementId,
          increment: false,
          start: 1
        },
        billingGroup: {
          base: props.placement.billingGroup,
          increment: false,
          start: 1
        },
        dates: {
          base: 'no-adjustment',
          increment: false,
          start: 1
        },
        errors: {}
      },
      placementCopies: []
    }
  }

  handleClone = (/* evt */) => {
    const { onClone, placement } = this.props;
    const { placementCopies } = this.state;
    return onClone(placement, placementCopies);
  }

  handleChange = (evt) => {
    const newCloneSettings = Object.assign({}, this.state.cloneSettings);
    const { placement, maxCopies } = this.props;

    const fullName = (evt.target.id && !evt.target.name)  ? evt.target.id : evt.target.name;

    const [ name, subcat ] = fullName.split('.');
    let { value } = evt.target;

    if (name === 'copies') {
      if (value > maxCopies) {
        value = maxCopies > 0 ? maxCopies : 0;
      }
    }

    if (subcat === 'base') {
      const err = validate(value, this.placementValidationRules[name]);
      if (err) {
        newCloneSettings.errors[name] = err;
      } else {
        delete newCloneSettings.errors[name];
      }
    }

    if (subcat) {
      newCloneSettings[name][subcat] = (subcat === 'increment') ?
        !newCloneSettings[name][subcat] : value;
    } else {
      newCloneSettings[name] = value;
    }

    const newState = {
      cloneSettings: newCloneSettings,
      placementCopies: ClonePlacementPage.createPlacementCopies(placement, newCloneSettings)
    };
    this.setState(newState);
  }

  render = () => {
    const { classes, placement, onBack, maxCopies } = this.props;
    const { cloneSettings, placementCopies } = this.state;
    const disableClone = Object.keys(cloneSettings.errors).length > 0 || cloneSettings.copies < 1;
    return(
      <div>
        <ClonePlacementToolbar
          onBack={onBack}
          onClone={this.handleClone}
          disableClone={disableClone}
        />
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <ClonePlacementForm
                  placement={placement}
                  cloneSettings={cloneSettings}
                  onChange={this.handleChange}
                  maxCopies={maxCopies}
                  errors={cloneSettings.errors}
                />
              </Card>
            </Grid>
            {!!placementCopies && !!placementCopies.length && (
            <Grid item xs={12}>
              <Card>
                <ClonePlacementGrid placementCopies={placementCopies} />
              </Card>
            </Grid>
            )}
          </Grid>
        </div>
      </div>
    )
  }
}

ClonePlacementPage.propTypes = {
  placement: PropTypes.object.isRequired,
  maxCopies: PropTypes.number.isRequired
};

export default withStyles(styles)(ClonePlacementPage);
